import { render, staticRenderFns } from "./artist.about.vue?vue&type=template&id=aea41f04&scoped=true"
import script from "./artist.about.vue?vue&type=script&setup=true&lang=js"
export * from "./artist.about.vue?vue&type=script&setup=true&lang=js"
import style0 from "./artist.about.vue?vue&type=style&index=0&id=aea41f04&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aea41f04",
  null
  
)

export default component.exports